// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `footer {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
    padding: 40px 20px;
    align-items: flex-start;
    justify-content: space-around;
    background-color: var(--grey-06);
}

footer * {
    color: var(--white);
}

footer>div {
    display: flex;
    flex-direction: column;
    width: 200px;
}

footer a,
footer .style_socials__41Kh5 svg {
    margin: 7px 0px;
}

footer a:not(.style_email__N\\+B6H) {
    text-decoration: none;
}

footer .style_socials__41Kh5 {
    display: flex;
    justify-content: space-between;
    width: 120px;
}

footer .style_socials__41Kh5 svg {
    width: 25px;
    height: 25px;
}

footer .style_email__N\\+B6H {
    color: var(--primary-01);

}`, "",{"version":3,"sources":["webpack://./src/components/footer/style.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,kBAAkB;IAClB,uBAAuB;IACvB,6BAA6B;IAC7B,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,wBAAwB;;AAE5B","sourcesContent":["footer {\n    display: flex;\n    gap: 10px;\n    flex-wrap: wrap;\n    padding: 40px 20px;\n    align-items: flex-start;\n    justify-content: space-around;\n    background-color: var(--grey-06);\n}\n\nfooter * {\n    color: var(--white);\n}\n\nfooter>div {\n    display: flex;\n    flex-direction: column;\n    width: 200px;\n}\n\nfooter a,\nfooter .socials svg {\n    margin: 7px 0px;\n}\n\nfooter a:not(.email) {\n    text-decoration: none;\n}\n\nfooter .socials {\n    display: flex;\n    justify-content: space-between;\n    width: 120px;\n}\n\nfooter .socials svg {\n    width: 25px;\n    height: 25px;\n}\n\nfooter .email {\n    color: var(--primary-01);\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"socials": `style_socials__41Kh5`,
	"email": `style_email__N+B6H`
};
export default ___CSS_LOADER_EXPORT___;
